import React from "react";
import "./InfoSummaryCard.style.css";
const InfoSummaryCard = ({ data, layout, onAction, actionLabel }) => {
  if (!data) return null;
console.log(data);

  return (
    <div className="infoSummaryCard">

      <div className="infoSummaryContent">
        {layout.map((row, rowIndex) => (
          <div key={rowIndex} className="infoSummaryRow">
            {row.map((field, colIndex) => (
              <div
                key={colIndex}
                className={`infoSummaryCol ${field.span === 2 ? "span-2" : ""}`}
              >
                <span className="label">{field.label}</span>
                <p>
                  {typeof field.render === "function"
                    ? field.render(data[field.key])
                    : data[field.key] ?? "—"}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div>

      {onAction && (
        <button className="infoSummaryBtn" onClick={onAction}>
          {actionLabel || "Confirm"}
        </button>
      )}
    </div>
  );
};

export default InfoSummaryCard;
